
import { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import StickyCTABar from "./StickyCTABar";

interface LayoutProps {
  children: ReactNode;
  showCTA?: boolean;
  showQuizBubble?: boolean;
  showMobileTabs?: boolean;
}

const Layout = ({ 
  children, 
  showCTA = true, // Changed default to true so it shows by default
  showQuizBubble = false,
  showMobileTabs = false
}: LayoutProps) => {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Header />
      <main className="pt-32 pb-20 md:pb-0 safe-area-top safe-area-bottom">{children}</main>
      <Footer />
      {showCTA && <StickyCTABar />}
    </div>
  );
};

export default Layout;
